<template>
  <div>
    <div class="weekWrapper">
      <div>
        <div class="btn-group" role="group" aria-label="Basic example">
          <b-form-datepicker
            width="100%"
            :date-disabled-fn="isCalDisabled"
            v-model="innerStartDate"
            @context="dateSelected"
            button-only="true;"
            :value-as-date="true"
            button-variant="outline-light"
          >
          </b-form-datepicker>

          <b-button variant="outline-light" @click="previousWeek"
            ><i class="fas fa-arrow-left"></i
          ></b-button>

          <div class="btn" style="height:43px;width:200px">
            {{ this.innerStartDate | moment("MMM Do") }} -
            {{ this.innerEndDate | moment("MMM Do") }}
          </div>

          <b-button variant="outline-light" @click="nextWeek"
            ><i class="fas fa-arrow-right"></i
          ></b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["dateService"],

  watch: {
    startDate: {
      immediate: true,
      handler(startDate, o) {
        this.innerStartDate = startDate;
        this.innerEndDate = this.dateService.addDays(startDate, 6);
      },
    },
  },
  data() {
    return {
      innerStartDate: null,
      innerEndDate: null,
      popoverShow: false,
    };
  },
  props: {
    startDate: {
      type: Date,
      required: true,
    },
  },
  methods: {
    isCalDisabled(fm, date) {
      return date.getDay() != 0;
    },
    dateSelected(d) {
      var dt = new Date(d.selectedDate);

      this.$emit("dateUpdate", this.innerStartDate);

      this.popoverShow = false;
    },
    previousWeek() {
      var pd = this.dateService.addDays(this.startDate, -7);

      this.$emit("dateUpdate", pd);
    },
    nextWeek() {
      var nd = this.dateService.addDays(this.startDate, 7);

      this.$emit("dateUpdate", nd);
    },
  },
};
</script>

<style scoped></style>
